// `${presenterLink}/share/${$store.state.presentation.shareCode}?presenting=true`
const install = (Vue) => {
  Vue.prototype.$var = {
    presenterURL: window.location.origin,
  }
}

export default {
  install,
}
